<div class="wizard-completed-wrapper">
	
	<h1>Survey Completed</h1>
	
	<div class="completion-graphic">
		
		<span class="material-symbols-outlined">star_shine</span>
	
	</div>
	
	<div class="link-container">
		
		<a href="https://cal.com/neatlyliving" class="nlv-btn">Book Appointment</a>
	
	</div>

</div>
